import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import auth from "../../services/authService";
import MenuItem from "../../comman/MenuItem";
import { resolveActiveLeftMenuPath } from "../../app/Layout/Private/leftMenuBreadcrumbs";
import { loadRolePermission, loadUserDetails } from "../../app/store/auth";

const BaseMenu = ({ isCollapsed, onToggleCollapse, onClickToggle, children }) => {
  const [currentUser, setCurrentUser] = useState("");
  const [user, setUser] = useState("");
  const [isSelected, setIsSelected] = useState("");
  const [rolePermission, setRolePermission] = useState([]);
  const [isHoverExpanded, setIsHoverExpanded] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const activeMenuPath = resolveActiveLeftMenuPath(location.pathname, location.state);

  useEffect(() => {
    const loadUserData = async () => {
      const loggedInUser = auth.getCurrentUser();
      if (loggedInUser === null || loggedInUser === undefined) {
        window.location = "/Login";
        return;
      }
      setUser(loggedInUser);

      const details = await dispatch(loadUserDetails(loggedInUser.id));
      if (!details) return;
      setCurrentUser(details);

      if (loggedInUser.type !== "admin") {
        const permission = await dispatch(loadRolePermission(details.roleId));
        setRolePermission(permission);
      }
    };
    loadUserData();
  }, [dispatch]);

  const handleLinkClick = () => {
    onClickToggle(false);
  };

  const handleClick = (e) => {
    setIsSelected(e.currentTarget.id);
  };

  const checkMenuPermission = (mid) => {
    if (!rolePermission) return;
    const loggedInUser = auth.getCurrentUser();
    if (loggedInUser.type === "admin") return true;
    const mm = mid.split("_");
    let chk = false;
    if (mm[0] === "m") {
      const mR = rolePermission.filter(
        (x) => x.id === parseInt(mm[1]) && x.isChecked === true
      );
      if (mR.length > 0) {
        chk = true;
      } else {
        rolePermission.filter((x) => x.id === parseInt(mm[1]))
          .map((menu) => {
            const sMenu = menu.menus.filter((x) => x.isChecked === true);
            if (sMenu.length > 0) {
              chk = true;
            } else {
              menu.menus.map((ssmenu) => {
                if (ssmenu?.menus) {
                  const ssMenu = ssmenu.menus.filter(
                    (x) => x.isChecked === true
                  );
                  if (ssMenu.length > 0) {
                    chk = true;
                  }
                }
              });
            }
          });
      }
    }
    if (mm[0] === "sm") {
      rolePermission
        .filter((x) => x.id === parseInt(mm[2]))
        .map((menu) => {
          const sMenu = menu.menus.filter(
            (x) => x.id === parseInt(mm[1]) && x.isChecked === true
          );
          if (sMenu.length > 0) {
            chk = true;
          } else {
            menu.menus.map((smenu) => {
              if (smenu?.menus) {
                const ssMenu = smenu.menus.filter((x) => x.isChecked === true);
                if (ssMenu.length > 0) {
                  chk = true;
                }
              } else {
                if (smenu?.isChecked) {
                  chk = true;
                }
              }
            });
          }
        });
    }
    if (mm[0] === "ssm") {
      rolePermission
        .filter((x) => x.id === parseInt(mm[3]))
        .map((menu) =>
          menu.menus
            .filter((x) => x.id === parseInt(mm[2]))
            .map((ssmenu) => {
              if (ssmenu?.menus) {
                const ssMenu = ssmenu.menus.filter(
                  (x) => x.id === parseInt(mm[1]) && x.isChecked === true
                );
                if (ssMenu.length > 0) {
                  chk = true;
                }
              } else {
                if (ssmenu?.isChecked) chk = true;
              }
            })
        );
    }
    return chk;
  };

  const isCollapsedRail = isCollapsed && !isHoverExpanded;
  const isEffectivelyExpanded = !isCollapsedRail;

  const getWorkplaceName = () => {
    const wp = localStorage.getItem("selectedWorkplace");
    if (wp === "recruitment") return "Recruitment";
    if (wp === "onboarding") return "Onboarding";
    if (wp === "safety") return "Safety Management";
    return "";
  };

  const workplaceName = getWorkplaceName();

  return (
    <nav
      className="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white shadow-none"
      id="sidenav-main"
      data-collapsed={isCollapsedRail ? "true" : "false"}
      data-hovered={isHoverExpanded ? "true" : "false"}
      onMouseEnter={() => {
        if (isCollapsed) setIsHoverExpanded(true);
      }}
      onMouseLeave={() => {
        if (isCollapsed) setIsHoverExpanded(false);
      }}
    >
      <style>{`
        #sidenav-main {
          background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%) !important;
          border-right: 1px solid rgba(203, 213, 225, 0.8) !important;
          box-shadow: 8px 0 24px rgba(15, 23, 42, 0.05) !important;
          overflow: hidden !important;
          overflow-y: hidden !important;
          transform: none !important;
        }
        #sidenav-main::-webkit-scrollbar {
          display: none !important;
          width: 0 !important;
          height: 0 !important;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"],
        #sidenav-main[data-collapsed="true"][data-hovered="false"]:hover,
        #sidenav-main[data-collapsed="true"][data-hovered="false"]:focus,
        #sidenav-main[data-collapsed="true"][data-hovered="false"]:focus-within {
          width: 120px !important;
          min-width: 120px !important;
          max-width: 120px !important;
          transform: none !important;
        }

        #sidenav-main[data-collapsed="false"][data-hovered="true"],
        #sidenav-main[data-collapsed="false"][data-hovered="false"] {
          width: 280px !important;
          min-width: 280px !important;
          max-width: 280px !important;
          box-shadow: 12px 0 30px rgba(15, 23, 42, 0.12) !important;
        }

        #sidenav-main[data-collapsed="false"] .navbar-brand {
          display: flex !important;
          align-items: center;
          justify-content: flex-start;
          width: auto;
        }

        #sidenav-main[data-collapsed="false"] .sidenav-header {
          flex-direction: row;
          align-items: flex-start !important;
          justify-content: space-between;
          gap: 0;
          padding-bottom: 0px;
        }

        #sidenav-main[data-collapsed="false"] .ml-auto {
          margin-left: auto !important;
          width: auto;
          display: block;
        }

        #sidenav-main[data-collapsed="false"] .premium-sidebar-heading {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          max-width: none;
        }

        #sidenav-main[data-collapsed="false"] .premium-sidebar-heading i {
          margin-right: 0.5rem !important;
        }

        #sidenav-main .scrollbar-inner {
          height: 100%;
          overflow-y: auto !important;
          overflow-x: hidden;
          padding: 10px 10px 18px 10px;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
        }
        #sidenav-main .scrollbar-inner::-webkit-scrollbar {
          width: 8px !important;
          height: 8px !important;
        }
        #sidenav-main .scrollbar-inner::-webkit-scrollbar-track {
          background: #f1f5f9 !important;
          border-radius: 999px !important;
        }
        #sidenav-main .scrollbar-inner::-webkit-scrollbar-thumb {
          background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%) !important;
          border-radius: 999px !important;
          border: 2px solid #f1f5f9 !important;
        }
        #sidenav-main .scrollbar-inner::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%) !important;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .scrollbar-inner {
          padding-left: 12px;
          padding-right: 12px;
        }

        #sidenav-main .navbar-nav {
          gap: 0px;
        }

        #sidenav-main .nav.nav-sm {
          border-left: 1px solid rgba(203, 213, 225, 0.8);
          margin-left: 16px;
          padding-left: 8px;
        }

        #sidenav-main .nav.nav-sm .nav-link {
          margin-left: 0 !important;
          margin-right: 0 !important;
          font-size: 13px !important;
        }

        #sidenav-main .nav-link[data-toggle="collapse"]::after,
        #sidenav-main .nav-link[aria-expanded]::after,
        #sidenav-main .nav-link::after {
          display: none !important;
          content: none !important;
        }

        #sidenav-main .nav-item {
          margin-bottom: 2px;
        }

        #sidenav-main .premium-sidebar-heading {
          background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%) !important;
          border: 1px solid rgba(203, 213, 225, 0.7) !important;
          border-radius: 14px !important;
          padding: 10px 12px !important;
          font-size: 14px;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          color: #1e293b !important;
          box-shadow: 0 8px 18px rgba(15, 23, 42, 0.04);
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          max-width: none;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .premium-sidebar-heading {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 11px 8px !important;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .premium-sidebar-heading i {
          margin-right: 0 !important;
        }

        #sidenav-main .collapse.show {
          margin-top: 6px;
        }

        #sidenav-main .nav-link {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          gap: 12px;
          width: 100%;
          box-sizing: border-box;
          min-height: 42px;
          padding: 10px 12px !important;
          border-radius: 12px !important;
          font-size: 14px;
          font-weight: 600;
          color: #1f2937 !important;
          transition: background-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
        }

        #sidenav-main .nav-link:hover {
          background: rgba(37, 99, 235, 0.08) !important;
          box-shadow: inset 0 0 0 1px rgba(59, 130, 246, 0.08) !important;
          border-radius: 12px !important;
          transform: none !important;
          text-decoration: none !important;
        }

        #sidenav-main .menu-parent-link,
        #sidenav-main .menu-parent-link:hover {
          background: transparent !important;
          box-shadow: none !important;
          color: #1f2937 !important;
          cursor: default !important;
          pointer-events: none !important;
          transform: none !important;
        }

        #sidenav-main .nav-link.active {
          background: linear-gradient(135deg, rgba(29, 78, 216, 0.12) 0%, rgba(37, 99, 235, 0.08) 100%) !important;
          color: #163b73 !important;
          border-radius: 12px !important;
          box-shadow: inset 3px 0 0 #2563eb, 0 10px 20px rgba(37, 99, 235, 0.08) !important;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .nav-link {
          justify-content: center;
          padding-left: 10px !important;
          padding-right: 10px !important;
          min-height: 56px;
        }

        #sidenav-main[data-collapsed="false"] .nav.nav-sm .nav-link,
        #sidenav-main[data-hovered="true"] .nav.nav-sm .nav-link {
          justify-content: flex-start !important;
          gap: 10px !important;
        }

        #sidenav-main[data-collapsed="true"] .navbar-brand {
          display: flex !important;
          align-items: center;
          justify-content: center;
          width: 100%;
          margin-left: 0 !important;
          padding-left: 0 !important;
          padding-right: 0 !important;
        }

        #sidenav-main[data-collapsed="true"] .sidenav-header {
          flex-direction: column;
          gap: 10px;
          padding-bottom: 10px;
          align-items: center !important;
        }

        #sidenav-main[data-collapsed="true"] .ml-auto {
          margin-left: 0 !important;
          width: 100%;
          display: flex;
          justify-content: center;
        }

        #sidenav-main .menu-toggle {
          width: 36px;
          height: 36px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border: 1px solid rgba(226, 232, 240, 1);
          border-radius: 10px;
          background: #ffffff;
          cursor: pointer;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          color: #64748b;
        }

        #sidenav-main .menu-toggle:hover {
          background: #f8fafc;
          border-color: #cbd5e1;
          color: #0f172a;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04);
          transform: translateY(-1px);
        }

        #sidenav-main[data-collapsed="false"] .menu-toggle,
        #sidenav-main[data-hovered="true"] .menu-toggle {
          margin-top: 14px !important;
        }

        #sidenav-main .menu-toggle i {
          font-size: 18px;
          line-height: 1;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .menu-toggle {
          width: 44px;
          height: 44px;
          margin-top: 14px !important;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .nav-link-text {
          display: none;
        }

        #sidenav-main[data-collapsed="false"] .nav-link-text,
        #sidenav-main[data-hovered="true"] .nav-link-text {
          display: inline-block !important;
          opacity: 1 !important;
          visibility: visible !important;
          max-width: 200px !important;
          white-space: nowrap !important;
          text-overflow: ellipsis !important;
          overflow: hidden !important;
        }

        #sidenav-main[data-collapsed="false"] .nav.nav-sm,
        #sidenav-main[data-hovered="true"] .nav.nav-sm {
          display: flex !important;
        }

        #sidenav-main[data-collapsed="false"] .collapse.show,
        #sidenav-main[data-hovered="true"] .collapse.show {
          display: block !important;
          height: auto !important;
          visibility: visible !important;
          opacity: 1 !important;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .nav.nav-sm {
          display: none !important;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .nav-link {
          position: relative;
        }
        
        #sidenav-main .sidebar-brand-mark {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
          color: #ffffff;
          font-size: 22px;
          font-weight: 800;
          box-shadow: 0 4px 14px rgba(37, 99, 235, 0.25);
          text-shadow: 0 2px 4px rgba(0,0,0,0.1);
          border: 1px solid rgba(255,255,255,0.1);
        }
      `}</style>
      <div className="scrollbar-inner">
        <div className="sidenav-header d-flex align-items-start justify-content-between w-100" style={{ boxSizing: "border-box", marginTop: "10px" }}>
          <a
            className="navbar-brand m-0 p-0"
            href="/Dashboard"
          >
            {isCollapsedRail ? (
              <span className="sidebar-brand-mark">W</span>
            ) : (
              <div className="d-flex flex-column align-items-start">
                <img
                  src="/assets/img/wflogoblack.png"
                  className="navbar-brand-img"
                  alt="Workfinity"
                />
                {workplaceName && (
                  <div style={{
                    marginTop: "8px",
                    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.08) 0%, rgba(29, 78, 216, 0.03) 100%)",
                    border: "1px solid rgba(37, 99, 235, 0.15)",
                    borderRadius: "8px",
                    padding: "5px 10px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    boxShadow: "0 2px 4px rgba(37, 99, 235, 0.02)"
                  }}>
                    <div style={{ width: "6px", height: "6px", borderRadius: "50%", background: "#2563eb", boxShadow: "0 0 0 2px rgba(37, 99, 235, 0.2)" }}></div>
                    <span style={{ fontSize: "11px", fontWeight: "800", color: "#1e3a8a", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                      {workplaceName}
                    </span>
                  </div>
                )}
              </div>
            )}
          </a>

          <div className="ml-auto d-flex align-items-center" style={{ height: "44px" }}>
            <button
              type="button"
              className="menu-toggle m-0"
              onClick={onToggleCollapse}
              role="button"
              aria-label={isCollapsedRail ? "Expand menu" : "Collapse menu"}
            >
              <i
                className={`fa ${isCollapsedRail ? "fa-bars" : "fa-angle-left"}`}
                aria-hidden="true"
              ></i>
            </button>
          </div>
        </div>
        <div className="navbar-inner" style={{ marginTop: "-20px" }}>
          <div className="collapse navbar-collapse" id="sidenav-collapse-main">
            <ul className="navbar-nav">
              {children({
                checkMenuPermission,
                isEffectivelyExpanded,
                isSelected,
                handleClick,
                handleLinkClick,
                activeMenuPath
              })}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default BaseMenu;
